import axios from 'axios';
/**
 * 组织
 * @returns {*}
 */

export function companyOrgsApi(option) {
    return axios.get('/system/organization/company-orgs', { params: option });
}

/**
 * 下级组织
 * @returns {*}
 */

export function findChildrenApi(option) {
    return axios.get('./system/organization/find-children', { params: option });
}

/**
 * 系统规则配置
 * @returns {*}
 */
export function getRuleConfigApi(option) {
    return axios.get('/system/rule-config/key', { params: option });
}

/**
 * 评分接口
 * @returns {*}
 */
export function userScoreApi(id) {
    const url = `/course-study/score/${id}`;
    return axios.get(url);
}

